import Vue from "vue";
import config from "@/config";
import dayjs from "dayjs-ext";
import i18n from "@/i18n";
import timeMachineService from "@/library/_xhr-timemachine.js";

const getDefaultState = function () {
  return {
    betMinsGap: 6,
    runningTime: 0,
    min: 6,
    max: 90,
    homet: '',
    awayt: '',
    matchId: 0,
    minutesOddsData: [],
    source: [],
    betInfo: null
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_TIME_MACHINE: function (state, payload) {
      for (var key in payload) {
        Vue.set(state, key, payload[key]);
      }
    },

    RESET_STATE: function (state) {
      Object.assign(state, getDefaultState());
    },

    SELECTED_TM_ODDS: function (state) {
      const preserved = {
        betInfo: state.betInfo
      }

      Object.assign(state, getDefaultState(), preserved);
    },
  },
  actions: {
    prepareTimeMachine({ commit, state }, payload = {}) {
      var runningTime = payload.runningTime != null ? payload.runningTime : state.runningTime;

      const preparedPayload = {
        betInfo: payload.betInfo || state.betInfo,
        source: payload.source || state.source,
        matchId: payload.matchId || state.matchId,
        runningTime: runningTime,
        min: payload.min != null ? payload.min : state.min,
        max: payload.max != null ? payload.max : state.max,
        homet: payload.homet,
        awayt: payload.awayt
      };

      commit("SET_TIME_MACHINE", preparedPayload)

      return preparedPayload;
    },
    getMatchRunningMinutes({ }, payload = {}) {
      if (payload.source.marketId < 3) {
        return 0;
      }

      if (!payload.source.runningTime) {
        return 90;
      }

      var rt_val = payload.source.runningTime.trim().toUpperCase();

      // LIVE
      if (["LIVE"].some(v => rt_val.includes(v))) {
        return 0;
      }

      // Half Time
      if (["H.TIME", "HT"].some(v => rt_val.includes(v))) {
        return 45;
      }

      const match = rt_val.match(/(1H|2H)\s*(\d+)'/);

      if (!match) return 90;

      const half = match[1] === "2H" ? 2 : 1;

      let minutes = parseInt(match[2]) || 0;

      // cap regular time to 45
      minutes = Math.min(minutes, 45);

      if (half === 1) {
        return minutes;
      }

      if (half === 2) {
        return Math.min(45 + minutes, 90);
      }

      return 90;
    },
    async fetchTimeMachine({ commit, rootGetters }, payload) {
      const args = {
        account_id: rootGetters.accountId || "",
        session_token: rootGetters.sessionToken || "",
        match_id: payload.matchId,
        odds_type: config.oddsTypeId[rootGetters.pageDisplay.oddsType.toUpperCase()]
      };

      return timeMachineService.betTimeMachineMinutes(args)
        .then(res => {
          if (res && res.success) {
            if (payload.runningTime >= 82) {
              return Promise.reject(res);
            }

            commit("SET_TIME_MACHINE", {
              ...payload,
              minutesOddsData: res.data.mins || [],
              loadingTimeMachine: false
            });
            return payload;

          } else {
            return Promise.reject(res);
          }
        });
    },
    setTimeMachine({ dispatch, state }, payload) {
      return dispatch("getMatchRunningMinutes", payload).then(
        async minutes => {
          var min_limit = minutes + state.betMinsGap >= state.max ? state.max : minutes + state.betMinsGap;
          return await dispatch("prepareTimeMachine", { runningTime: minutes, min: min_limit, ...payload })
            .then(async preparedPayload => {
              return await dispatch("fetchTimeMachine", preparedPayload);
            });
        }
      );
    },
  }
};
